import { aboutData } from '@/mocks/homeData';

export default function SectionAbout() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          {aboutData.title}
        </h2>
        <div className="flex flex-col gap-4 mt-8">
          {aboutData.paragraphs.map((p, i) => (
            <p key={i} className="text-sm md:text-base text-foreground-600 leading-relaxed">
              {p}
            </p>
          ))}
        </div>
      </div>
    </section>
  );
}